import styled from 'styled-components';

export const ReviewSection = styled.section`
  position: relative;
  display: flex;
  align-items: center;
  min-height: 870px;
  padding: 25px 0;

  @media only screen and (max-width: 767px) {
    display: block;
    min-height: 10px;
    padding: 45px 0;
  }

  .content {
    @media only screen and (max-width: 767px) {
      text-align: center;
    }

    h4 {
      font-family: Vollkorn, sans-serif;
      font-size: 47px;
      letter-spacing: -0.36px;
      line-height: 57px;
      margin-bottom: 57px;

      @media only screen and (max-width: 1024px) {
        font-size: 32px;
        line-height: 42px;
      }

      @media only screen and (max-width: 767px) {
        font-size: 22px;
        line-height: 31px;
        margin-bottom: 20px;
      }
    }

    p {
      font-size: 16px;
      letter-spacing: -0.12px;
      line-height: 30px;
      margin: 0;
    }

    .pink-btn {
      margin-top: 30px;

      @media only screen and (max-width: 767px) {
        display: block;
      }
    }
  }

  .image {
    width: 50%;
    height: 100%;
    background-size: cover;
    background-position: top center;

    @media only screen and (max-width: 767px) {
      display: none;
    }
  }
`;
